import * as assert from 'assert';
import * as moment from 'moment';

// sets custom string for AM / PM to match designs
const ENGLISH_LOCALE_CODE: string = 'en';
moment.updateLocale(ENGLISH_LOCALE_CODE, {
    meridiem: function (hour: number, minute: number, isLowercase: boolean) {
        if (isLowercase) {
            if (hour > 11) {
                return 'pm';
            } else {
                return 'am';
            }
        } else {
            if (hour > 11) {
                return 'P.M.';
            } else {
                return 'A.M.';
            }
        }
    }
});

export interface INewScan {
    user_id: number;
    facility_id: number;
    machine_name: string;
    weight_lbs: number;
    scan_results: string | object;
}

export interface IUpdateScan {
}

export interface IScan {
    id: number;
    user_id: number;
    facility_id: number;
    machine_name: string;
    weight_lbs: number;
    scan_results: IScanResults;
    created_at: string;
}

export class Scan {
    id: number;
    user_id: number;
    facility_id: number;
    machine_name: string;
    weight_lbs: number;
    scan_results: IScanResults;
    created_at: moment.Moment;

    public constructor(args: IScan) {
        assert(undefined != args, 'Scan constructor passed null or undefined args object');
        assert(typeof args.id === 'number', 'Scan constructor passed args with invalid id');
        assert(typeof args.user_id === 'number', 'Scan constructor passed args with invalid user_id');
        assert(typeof args.facility_id === 'number', 'Scan constructor passed args with invalid facility_id');
        assert(typeof args.machine_name === 'string', 'Scan constructor passed args with invalid machine_name');
        assert(typeof args.weight_lbs === 'number', 'Scan constructor passed args with invalid weight_lbs');
        assert(
            null != args.scan_results && typeof args.scan_results === 'object',
            'Scan constructor passed args with invalid weight_lbs'
        );
        assert(typeof args.created_at === 'string', 'Scan constructor passed args with invalid created_at');

        this.id = args.id;
        this.user_id = args.user_id;
        this.facility_id = args.facility_id;
        this.machine_name = args.machine_name;
        this.weight_lbs = args.weight_lbs;

        this.scan_results = new ScanResults(args.scan_results);

        this.created_at = moment(args.created_at);
    }
}

export interface IScanResults {
    visceralFatLevel: number;
    weightPounds: number;
    bodyFatMassPounds: number;
    totalBodyWaterPounds: number;
    fatFreeMassPounds: number;
    skeletalMuscleMassPounds: number;
    bodyMassIndex: number;
    percentBodyFat: number;
    basalMetabolicRate: number;
    dryLeanMassPounds: number;
    fatFreeMassPercentRightArm: number;
    fatFreeMassPercentLeftArm: number;
    fatFreeMassPercentTrunk: number;
    fatFreeMassPercentRightLeg: number;
    fatFreeMassPercentLeftLeg: number;
    fatFreeMassPoundsRightArm: number;
    fatFreeMassPoundsLeftArm: number;
    fatFreeMassPoundsTrunk: number;
    fatFreeMassPoundsRightLeg: number;
    fatFreeMassPoundsLeftLeg: number;
}

export class ScanResults {
    visceralFatLevel: number;
    weightPounds: number;
    bodyFatMassPounds: number;
    totalBodyWaterPounds: number;
    fatFreeMassPounds: number;
    skeletalMuscleMassPounds: number;
    bodyMassIndex: number;
    percentBodyFat: number;
    basalMetabolicRate: number;
    dryLeanMassPounds: number;
    fatFreeMassPercentRightArm: number;
    fatFreeMassPercentLeftArm: number;
    fatFreeMassPercentTrunk: number;
    fatFreeMassPercentRightLeg: number;
    fatFreeMassPercentLeftLeg: number;
    fatFreeMassPoundsRightArm: number;
    fatFreeMassPoundsLeftArm: number;
    fatFreeMassPoundsTrunk: number;
    fatFreeMassPoundsRightLeg: number;
    fatFreeMassPoundsLeftLeg: number;

    public constructor(args: IScanResults) {
        assert(undefined != args, 'ScanResults constructor passed null or undefined args object');
        assert(typeof args.visceralFatLevel === 'number', 'ScanResults#constructor - invalid visceralFatLevel');
        assert(typeof args.weightPounds === 'number', 'ScanResults#constructor - invalid weightPounds');
        assert(typeof args.bodyFatMassPounds === 'number', 'ScanResults#constructor - invalid bodyFatMassPounds');
        assert(typeof args.totalBodyWaterPounds === 'number', 'ScanResults#constructor - invalid totalBodyWaterPounds');
        assert(typeof args.fatFreeMassPounds === 'number', 'ScanResults#constructor - invalid fatFreeMassPounds');
        assert(typeof args.skeletalMuscleMassPounds === 'number', 'ScanResults#constructor - invalid skeletalMuscleMassPounds');
        assert(typeof args.bodyMassIndex === 'number', 'ScanResults#constructor - invalid bodyMassIndex');
        assert(typeof args.percentBodyFat === 'number', 'ScanResults#constructor - invalid percentBodyFat');
        assert(typeof args.basalMetabolicRate === 'number', 'ScanResults#constructor - invalid basalMetabolicRate');
        assert(typeof args.dryLeanMassPounds === 'number', 'ScanResults#constructor - invalid dryLeanMassPounds');
        assert(typeof args.fatFreeMassPercentRightArm === 'number', 'ScanResults#constructor - invalid fatFreeMassPercentRightArm');
        assert(typeof args.fatFreeMassPercentLeftArm === 'number', 'ScanResults#constructor - invalid fatFreeMassPercentLeftArm');
        assert(typeof args.fatFreeMassPercentTrunk === 'number', 'ScanResults#constructor - invalid fatFreeMassPercentTrunk');
        assert(typeof args.fatFreeMassPercentRightLeg === 'number', 'ScanResults#constructor - invalid fatFreeMassPercentRightLeg');
        assert(typeof args.fatFreeMassPercentLeftLeg === 'number', 'ScanResults#constructor - invalid fatFreeMassPercentLeftLeg');
        assert(typeof args.fatFreeMassPoundsRightArm === 'number', 'ScanResults#constructor - invalid fatFreeMassPoundsRightArm');
        assert(typeof args.fatFreeMassPoundsLeftArm === 'number', 'ScanResults#constructor - invalid fatFreeMassPoundsLeftArm');
        assert(typeof args.fatFreeMassPoundsTrunk === 'number', 'ScanResults#constructor - invalid fatFreeMassPoundsTrunk');
        assert(typeof args.fatFreeMassPoundsRightLeg === 'number', 'ScanResults#constructor - invalid fatFreeMassPoundsRightLeg');
        assert(typeof args.fatFreeMassPoundsLeftLeg === 'number', 'ScanResults#constructor - invalid fatFreeMassPoundsLeftLeg');

        this.visceralFatLevel = args.visceralFatLevel;
        this.weightPounds = args.weightPounds;
        this.bodyFatMassPounds = args.bodyFatMassPounds;
        this.totalBodyWaterPounds = args.totalBodyWaterPounds;
        this.fatFreeMassPounds = args.fatFreeMassPounds;
        this.skeletalMuscleMassPounds = args.skeletalMuscleMassPounds;
        this.bodyMassIndex = args.bodyMassIndex;
        this.percentBodyFat = args.percentBodyFat;
        this.basalMetabolicRate = args.basalMetabolicRate;
        this.dryLeanMassPounds = args.dryLeanMassPounds;
        this.fatFreeMassPercentRightArm = args.fatFreeMassPercentRightArm;
        this.fatFreeMassPercentLeftArm = args.fatFreeMassPercentLeftArm;
        this.fatFreeMassPercentTrunk = args.fatFreeMassPercentTrunk;
        this.fatFreeMassPercentRightLeg = args.fatFreeMassPercentRightLeg;
        this.fatFreeMassPercentLeftLeg = args.fatFreeMassPercentLeftLeg;
        this.fatFreeMassPoundsRightArm = args.fatFreeMassPoundsRightArm;
        this.fatFreeMassPoundsLeftArm = args.fatFreeMassPoundsLeftArm;
        this.fatFreeMassPoundsTrunk = args.fatFreeMassPoundsTrunk;
        this.fatFreeMassPoundsRightLeg = args.fatFreeMassPoundsRightLeg;
        this.fatFreeMassPoundsLeftLeg = args.fatFreeMassPoundsLeftLeg;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/data_layer/models/Scan.ts